import React from 'react';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

/**
 * International phone input. Stores the value as an E.164 string (e.g.
 * "+14155551234") so it round-trips cleanly through the API and renders
 * as plain text in the submission view / PDF. `defaultCountry` seeds the
 * flag selector when the field is empty.
 *
 * When the user has typed anything, we run `isValidPhoneNumber` and surface
 * a red border + inline error message so typos get caught before submit.
 * Empty values are considered valid — phones are optional on this form.
 */
export default function PhoneField({ value, onChange, placeholder, defaultCountry = 'US', testId, className = '' }) {
  const trimmed = (value || '').trim();
  const hasValue = trimmed.length > 0 && trimmed !== '+';
  const invalid = hasValue && !isValidPhoneNumber(trimmed);

  return (
    <div className="w-full">
      <PhoneInput
        international
        defaultCountry={defaultCountry}
        value={value || ''}
        onChange={(v) => onChange(v || '')}
        placeholder={placeholder || 'Enter phone number'}
        className={`stpk-phone ${invalid ? 'stpk-phone-invalid' : ''} ${className}`}
        data-testid={testId}
      />
      {invalid && (
        <p className="mt-1 text-xs text-red-600" data-testid={testId ? `${testId}-error` : 'phone-error'}>
          Please enter a valid phone number for the selected country.
        </p>
      )}
    </div>
  );
}
